import { getUpchargeListActive } from "api/order";
import { OrderConfigContext } from "Context/OrderConfigContext";
import { useFormikContext } from "formik";
import { DEFAULT_TIMEZONE } from "Helpers/Constants";
import { convertDateTime } from "Helpers/date";
import { useContext, useEffect, useMemo, useState } from "react";

export function useDate() {
  const config = useContext(OrderConfigContext);
  const [blockoutDates, setBlockOutDates] = useState([]);
  const [tooltipDays, setTooltipDays] = useState([]);
  const [upchargeDatesArray, setUpchargeDatesArray] = useState([]);
  const [storeWiseUpchargeList, setStoreWiseUpchargeList] = useState([]);
  const formik = useFormikContext();

  let dependency = useMemo(() => {
    return {
      zip_code: formik.values.delivery_information?.zipcode,
      address_type_id: formik.values.delivery_information?.address_type_id,
      is_local: formik.values.delivery_information?.is_local,
      store_id: formik.values.billing_info.zip_code_store_id
    };
  }, [
    formik.values.delivery_information?.zipcode,
    formik.values.delivery_information?.address_type_id,
    formik.values.delivery_information?.is_local,
    formik.values.billing_info.zip_code_store_id
  ]);

  useEffect(() => {
    let blocks = [];
    if (config.blockoutList && config.blockoutList.length > 0) {
      blocks = config.blockoutList
        ?.filter((a) => {
          let zip_code_block = a.blockout_dates_zipcode_to_blocks.findIndex(
            (c) => c.store_settings_zipcode.zip_code === dependency.zip_code
          );

          let address_type_block =
            a.blockout_dates_delivery_address_types.findIndex(
              (c) => c.delivery_address_type_id === dependency.address_type_id
            );

          if (a.services_block_local_delivery && dependency.is_local) {
            return true;
          }

          if (a.services_block_non_local_delivery && !dependency.is_local) {
            return true;
          }

          if (zip_code_block !== -1) {
            return true;
          }

          if (address_type_block !== -1) {
            return true;
          }
          return false;
        })
        .map((a) => {
          return {
            from: new Date(
              convertDateTime(a.start_blocking_on, 'seconds2', "", "", formik?.values?.orderTimezone || DEFAULT_TIMEZONE)
            ),
            to: new Date(
              convertDateTime(a.stop_repeating_on, 'seconds2', "", "", formik?.values?.orderTimezone || DEFAULT_TIMEZONE)
            ),
          };
        });
    }
    setBlockOutDates(blocks);
  }, [dependency, config.blockoutList]);


  const getStoreWiseUpcharge = async () => {
    const response = await getUpchargeListActive({
      selectedStore: dependency.store_id || 0
    });
    let uplist = response?.data?.data?.rows;
    setStoreWiseUpchargeList(uplist || []);
  }

  useEffect(() => {
    getStoreWiseUpcharge();
  }, [dependency.store_id]);

  //Upcharge dates
  useEffect(() => {
    let upchargeDate = [];
    const uphargeList = dependency.store_id ? storeWiseUpchargeList : config.upchargeList;
    uphargeList?.forEach((c) => {
      let start_date = new Date(
        convertDateTime(+c.apllies_on, "seconds2", "", "", formik?.values?.orderTimezone || DEFAULT_TIMEZONE)          
      );
      let end_date = new Date(
        convertDateTime(+c.apllies_untill, "seconds2", "", "", formik?.values?.orderTimezone || DEFAULT_TIMEZONE)
      );
      for (let q = start_date; q <= end_date; q.setDate(q.getDate() + 1)) {
        let z;
        if (c.local && dependency.is_local) {
          z = {
            date: q.toISOString(),
            charge: c.amount,
            title: c.title,
            id: c.id,
          };
        } else if (c.non_local && !dependency.is_local) {
          z = {
            charge: c.amount,
            date: q.toISOString(),
            title: c.title,
            id: c.id,
          };
        }
        if (z) {
          upchargeDate.push(z);
        }
      }
    });
    let tooltipDays = upchargeDate?.map((a, i) => {
      return {
        id: i.toString(),
        date: convertDateTime(a.date, "iso5"),
        month: convertDateTime(a.date, "iso6"),
        year: convertDateTime(a.date, "iso7"),
        message: `${a.title} +$${a.charge}`,
      };
    });
    setTooltipDays(tooltipDays);
    setUpchargeDatesArray(upchargeDate);
  }, [dependency, config.upchargeList, storeWiseUpchargeList]);

  return {
    tooltipDays,
    blockoutDates,
    upchargeDatesArray,
  };
}
